import React, { memo, useContext } from "react";

//context
import { CartContext } from "@cart-client/contexts/CartContext";

//hooks
import { useCartRendererAnalytics } from "@cart-client/hooks/useCartRenderedAnalytics";

//helpers
import { isMROFlow } from "@cart-client/helpers/MROFoodCart";

//components
import { SelfDeliveryInstruction } from "@swiggy-private/cart-ui";

//types
import { RenderingDetails } from "@swiggy-private/cart-types";
import { Wrapper } from "./styles";

function SelfDeliveryInstructions({ itemData }: { itemData: RenderingDetails }) {
    const {
        cartState: { reviewedCart: cartResponse },
    } = useContext(CartContext);

    const { onImpressionSelfDeliveryInstruction } = useCartRendererAnalytics(cartResponse);

    return (
        <Wrapper>
            <SelfDeliveryInstruction
                itemData={itemData}
                allowTitleWrap={isMROFlow()}
                onImpressionSelfDeliveryInstruction={onImpressionSelfDeliveryInstruction}
            />
        </Wrapper>
    );
}

export default memo(SelfDeliveryInstructions);
